// extracted by mini-css-extract-plugin
export default {"customBGColor":"style_customBGColor__e0K7R","searhIcon":"style_searhIcon__87dG8"};